<script lang="ts">
    import { Col, ListGroup, ListGroupItem } from "sveltestrap";
    import { Crasjustoodio, Dapibusacfacilisisin, href, Linksandbuttons, Morbileorisus, Portaacconsecteturac, Vestibulumateros } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12" xl="12">
    <Card cardHeaderprops="pb-0" headerTitle={Linksandbuttons}>
      <div slot="contentbody">
        <ListGroup>
          <ListGroupItem active>{Crasjustoodio}</ListGroupItem>
          <ListGroupItem >{Dapibusacfacilisisin}</ListGroupItem>
          <ListGroupItem >{Morbileorisus}</ListGroupItem>
          <ListGroupItem >{Portaacconsecteturac}</ListGroupItem>
          <ListGroupItem disabled>{Vestibulumateros}</ListGroupItem>
        </ListGroup>
      </div>
    </Card>
</Col>